<ng-container *ngIf="!isRaised">
  <button (click)="onClicked($event)" class="icu-laoding-button icu-buttons" style="display: flex; justify-content: center; align-items: center; height: 100% !important;"
  [disabled]="loading || disabled" mat-stroked-button color="primary">
    <ng-content></ng-content>
    <span *ngIf="text">{{text}}</span>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </button>
</ng-container>
<ng-container *ngIf="isRaised">
  <button (click)="onClicked($event)" class="icu-laoding-button icu-buttons" style="display: flex; justify-content: center; align-items: center; height: 100% !important;"
  [disabled]="loading || disabled" mat-raised-button color="primary">
    <ng-content></ng-content>
    <span *ngIf="text">{{text}}</span>
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </button>
</ng-container>
